import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SGRESharedModule } from '../../SGRE-shared/SGRE-shared.module';
import { ConfigModule, I18nModule, provideDefaultConfig } from '@spartacus/core';
import { PageSlotModule } from '@spartacus/storefront';
import {
  TranslateLoader,
  TranslateModule,
  TranslateService,
  TranslateStore,
} from '@ngx-translate/core';
import { MultiTranslateHttpLoader } from 'ngx-translate-multi-http-loader';
import { HttpBackend } from '@angular/common/http';
import { PrimengModule } from '../primeng/primeng.module';
import { ReactiveFormsModule } from '@angular/forms';
import { CheckoutStoreModule } from './store/checkout-store.module';

import { customDefaultOccCheckoutConfig } from './config/default-occ-checkout-config';

import { CustomRouteGuard } from '../../SGRE-shared/services/guard/msal.guard';

import { SharedCheckoutService } from './services/sharedcheckout.service';
import { CheckoutService } from './services/checkout.service';
import { CheckoutTrackingService } from './services/checkout-tracking.service';

import { CheckoutDetailsComponent } from './Components/checkout-detail/checkout-details.component';
// import { PricedEntriesAccordionComponent } from './Components/priced-entries-accordion/priced-entries-accordion.component';
import { RequestAndDuplicateCartButtonComponent } from './Components/request-and-duplicate-cart-button/request-and-duplicate-cart-button.component';
import { CheckoutAccordionComponent } from './Components/checkout-accordion/checkout-accordion.component';
import { AccordionFormsComponent } from './Components/accordion-forms/accordion-forms.component';
import { AccordionPriceSummaryComponent } from './Components/accordion-price-summary/accordion-price-summary.component';

export function HttpLoaderFactory(http: HttpBackend) {
  return new MultiTranslateHttpLoader(http, ['/public/i18n/core/', '/public/i18n/vendors/']);
}

@NgModule({
  declarations: [
    CheckoutDetailsComponent,
    // PricedEntriesAccordionComponent,
    RequestAndDuplicateCartButtonComponent,
    CheckoutAccordionComponent,
    AccordionFormsComponent,
    AccordionPriceSummaryComponent
  ],
  imports: [
    CommonModule,
    PageSlotModule,
    SGRESharedModule,
    PrimengModule,
    ReactiveFormsModule,
    ConfigModule.withConfig({
      cmsComponents: {
        CheckoutDetailsComponent: {
          component: () => import('./Components/checkout-detail/checkout-details.component').then(m => m.CheckoutDetailsComponent),
          guards: [CustomRouteGuard]
        },
        PricedEntriesAccordionComponent: {
          component: () => import('./Components/checkout-accordion/checkout-accordion.component').then(m => m.CheckoutAccordionComponent),
          guards: [CustomRouteGuard]
        },
        RequestAndDuplicateCartButtonComponent: {
          component: () => import('./Components/request-and-duplicate-cart-button/request-and-duplicate-cart-button.component').then(m => m.RequestAndDuplicateCartButtonComponent),
          guards: [CustomRouteGuard]
        },
      }
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      }
    }),
    I18nModule,
    CheckoutStoreModule,
  ],
  providers: [
    TranslateService,
    SharedCheckoutService,
    { provide: TranslateStore },
    provideDefaultConfig(customDefaultOccCheckoutConfig),
    CheckoutService,
    CheckoutTrackingService,
  ]
})
export class CheckoutPageModule { }